import { __rest } from "tslib";
import React from 'react';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import MobileDialog from '@shared/ui/MobileDialog/MobileDialog';
import { BaseButton, Input } from '../../../BaseComponents';
import LocationOptionsList from '../LocationOptionsList/LocationOptionsList';
import Loader from '../../../Loader';
import { useCityOptions } from '../../../LocationAutocomplete/hooks';
import { LocationType } from '../../../types';
import { useTheme } from '../../../theme';
import { disableAutocompleteProps } from '../../../utils';
import { useDebounce } from '../../../hooks';
const MobileDropdown = (_a) => {
    var { isOpen, options, onClose, onInputChange, type, onAdditionalButtonClick, isLoading } = _a, listProps = __rest(_a, ["isOpen", "options", "onClose", "onInputChange", "type", "onAdditionalButtonClick", "isLoading"]);
    const { MobileDropdown: css } = useTheme('LocationAutocomplete');
    const { t } = useTranslation('LocationAutocomplete');
    const [query, setQuery] = useState('');
    const debouncedQuery = useDebounce(query, 500);
    const { dropdownOptions, showAdditionalButton } = useCityOptions(options);
    const onChange = (event) => {
        setQuery(event.target.value);
    };
    React.useEffect(() => {
        if (onInputChange) {
            const event = {
                target: { value: debouncedQuery },
                currentTarget: { value: debouncedQuery }
            };
            onInputChange(event);
        }
    }, [debouncedQuery, onInputChange]);
    return (React.createElement(MobileDialog, { title: `${t(type === LocationType.Departure ? 'From' : 'To')}`, isOpen: isOpen, onClose: onClose, footer: showAdditionalButton && onAdditionalButtonClick ? (React.createElement("div", { className: css.mobileDropdown__showAllDirectionsWrapper },
            React.createElement(BaseButton, { variant: "smallThird", className: css.mobileDropdown__showAllDirections, onMouseDown: onAdditionalButtonClick }, t('show all directions')))) : null },
        React.createElement(React.Fragment, null,
            React.createElement(Input, { name: "mobileDialogInput", className: css.mobileDropdown__input, type: "text", placeholder: `${t(type === LocationType.Departure ? 'From' : 'To')}`, value: query, onChange: onChange, autoFocus: true, spellCheck: false, autoCorrect: "off", inputProps: disableAutocompleteProps }),
            isLoading ? (React.createElement(Loader, { className: css.mobileDropdown__loader, hideText: true })) : (React.createElement(LocationOptionsList, Object.assign({ options: dropdownOptions, showButton: false }, listProps))))));
};
export default MobileDropdown;
